import { emailValidation } from "../helpers";
/**
 * Custom validation that can be re-used across inputs
 */
export const VALIDATION_MAP = {
  oneLetterOneNumber: (value: string): boolean | string => {
    if (/^(?=.*[0-9])(?=.*[a-zA-Z])(?=\S+$).*$/i.test(value)) {
      return true;
    }
    return "Field must contain at least 1 letter and 1 number.";
  },
  email: (value: string): boolean | string => {
    if (emailValidation.test(value)) {
      return true;
    }
    return "Must be a valid email.";
  },
  strawberryValidation: (value: string): boolean | string => {
    if (value === "strawberry") {
      return true;
    }
    return "example error";
  },
  exampleCustomValidation: (value: string): boolean | string => {
    if (value === "1") {
      return true;
    }
    return "example error";
  },
};
